<style lang="less">
.muddleheaded {
  align-items: center;
  height: 36px;
  width: 250px;
  //background-image: url("@/assets/comimg/comtitle-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
  padding-left: 14px;

  .title-icon-style {
    width: 32px;
    height: 32px;
    display: inline-block;
    //background: url("../../assets/modicon/ar-title-icon-img.png") no-repeat center 100%;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

.ar-cent-bg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.cent-padding {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.flex-box {
  display: flex;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 36px;
}

.btn-box {
  margin-left: -4px;
  display: flex;
  align-items: flex-end;

  span {
    display: inline-block;
    border: 1px solid #205dcb;
    padding: 4px 12px;
    margin-left: 10px;
  }
}

.absoluteClass {
  position: absolute;
}

.active {
  background-color: #0487ea;
}
</style>
<template>
  <div class="ar-cent-bg">
    <div
      class="flex-box"
      v-if="title"
      :style="{
        backgroundImage: `url(${require('@/assets/comimg/' + titlebg)})`,
        marginBottom: mgb + 'px',
      }"
    >
      <div v-bind:class="{ absoluteClass: absolute }" class="muddleheaded">
        {{ title }}
      </div>
      <div class="btn-box" v-if="list">
        <span
          @click="_btnFun(item)"
          class="sbs"
          :class="{ active: btnIndex == item.value }"
          :key="index"
          v-for="(item, index) in list"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div
      class="cent-padding"
      :style="{
        backgroundImage: `url(${require(`@/assets/comimg/itemboxbg/${bgimg}`)})`,
      }"
    >
      <slot></slot>
    </div>
    <!--    </dv-border-box-8>-->
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具 js，第三方插件 js，json 文件，图片文件等等）
// 例如：import  《组件名称》  from '《组件路径》 ';
export default {
  // import 引入的组件需要注入到对象中才能使用
  name: "modeheadtitle",
  props: {
    absolute: false,
    btnFun: {
      type: Function,
      default: function () {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "ar-title-icon-img.png",
    },
    // 内容背景
    bgimg: {
      type: String,
      default: "item-box-bg1.png",
    },
    // 标题背景
    titlebg: {
      type: String,
      default: "comtitle-bg.png",
    },
    // 下边距
    mgb: {
      type: Number,
      default: 4,
    },
  },
  // 这里存放数据
  data() {
    return {
      btnIndex: "",
    };
  },
  // 生命周期 - 创建完成（可以访问当前this 实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问 DOM 元素）
  mounted() {},
  // 方法集合
  methods: {
    _btnFun(item) {
      this.btnIndex = item.value;
      this.btnFun(item);
    },
  },
};
</script>
